// extracted by mini-css-extract-plugin
module.exports = {"details__btn":"styles_details__btn__YKG09","pulse":"styles_pulse__5TCyL","jump":"styles_jump__WyNeD"};